import { createRoot } from 'react-dom/client'
import { Suspense } from 'react'
import { Center, Stats } from '@react-three/drei'
import { Leva } from 'leva'
import './styles.css'
import App from './App'
import { Buttoncolor } from './Lamborghini'


export function Overlay() {
  
  return (
    <div style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none', width: '100%', height: '100%' }}>
      
      <div style={{ position: 'absolute', top: '14%', left: '50%', transform: 'translate3d(-50%,-50%,0)' }}>
        <h1 style={{ margin: 0, padding: 0, fontSize: '5em', fontWeight: 800, letterSpacing: '0.05em', fontStyle:'oblique',fontFamily:'Grand Sport' }}>CORVETTE</h1>
        
        
      </div>
      <div style={{ position: 'absolute', top: '24%', left: '50%', transform: 'translate3d(-50%,-50%,0)'}}>
      <h2 style={{ margin: 0, padding: 0, fontSize: '.8em',fontFamily:'montserrat', fontWeight: 300, letterSpacing: '0.02em', textAlign:'center' }}>The Chevrolet Corvette (C7) is the seventh generation of the Corvette sports car manufactured by American automobile manufacturer Chevrolet from 2014 until 2019. It was introduced for the 2014 model year as the first to bear the Corvette Stingray name since 1976. The first C7 Corvettes were delivered in the third quarter of 2013.</h2>

      </div>

      <div style={{ position: 'absolute', top: '9%', left: '50%', transform: 'translate3d(-50%,-50%,0)' }}>
        <h2 style={{ margin: 0, padding: 0, fontSize: '1.2em', fontWeight: 100, letterSpacing: '1.2em', fontFamily:'Grand Sport' }}>CHEVROLET</h2>

      </div>

      <div style={{ position: 'absolute', top: '19%', left: '50%', transform: 'translate3d(-50%,-50%,0)' }}>
      <h2 style={{ margin: 0, padding: 0, fontSize: '.8em',  fontWeight: 500, letterSpacing: '1.2em' , fontFamily:'Grand Sport' }}>C7 - 2014</h2>
      </div>

      <div style={{ position: 'absolute', top: 40, left: 40, fontSize: '13px',color:'white' }}>PRANAY BUBNA —</div>
      
      <div class="scroll-downs">
        <div class="mousey">
          <div class="scroller"></div>
        </div>
      </div>
      
    </div>
  )
}

createRoot(document.getElementById('root')).render(
  <Suspense fallback={null}>
    <App />
    {/* <Stats /> */}
    <Overlay/>
    <Leva hidden />
    <Buttoncolor/>
    
  </Suspense>
)

